function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M368 416H80V144h224.117l16-16H64v304h320V191.883l-16 16z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M237.623 284.084l-9.706-9.707L399.24 103.054 387.927 91.74 208 271.65V304h32.216L420.26 124.016l-11.313-11.286zM444.213 80.312l-12.465-12.466c-2.664-2.38-6.192-3.846-10.002-3.846a14.758 14.758 0 0 0-9.93 3.85L399.667 80l.08.08 11.293 11.293 21.02 21.02 12.15-12.15c2.382-2.625 3.79-6.117 3.79-9.93 0-3.81-1.408-7.338-3.787-10z"
});

function SvgIosCreateOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosCreateOutline);
export default __webpack_public_path__ + "static/media/ios-create-outline.3cdde715.svg";
export { ForwardRef as ReactComponent };